import React from 'react';
import { useFilters } from './useFilters';
import { CalendarIcon } from 'components/common/icons';
import { Col, DatePicker, Form, FormInstance, Input, LanguageSelect, Row } from 'components';
import { CountrySelect, FilterDrawer } from 'components/common';
import styles from 'pages/admin/clients/styles.module.scss';
import { RoleSelect } from 'components/common/roleSelect';
import { DepartmentSelect } from 'components/common/departmentSelect';

const { RangePicker } = DatePicker;

interface IFilters {
  form: FormInstance;
  drawerOpen: boolean;
  closeDrawer: () => void;
  applyFilters: (value: Record<string, any>) => void;
  resetFilters: () => void;
}

export const Filters = React.memo((props: IFilters) => {
  const { form, drawerOpen, closeDrawer, applyFilters, resetFilters } = props;
  const { clearFilters } = useFilters({ form, resetFilters });

  return (
    <FilterDrawer
      title="Filter"
      placement="left"
      width={471}
      styles={{
        body: {
          marginBottom: 80,
        },
      }} // Add space for drawer actions
      onClose={closeDrawer}
      open={drawerOpen}
      onApply={() => form.submit()}
      onClear={clearFilters}
      onExpand={closeDrawer}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={applyFilters}
        initialValues={{
          department: null,
          title: null,
          roleId: null,
          countryId: null,
          languages: [],
          createdDate: [null, null],
          lastUpdatedDate: [null, null],
        }}
      >
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Form.Item name="department" label={'Department'}>
              <DepartmentSelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="title" label={'Title'}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="roleIds" label={'Assigned Roles'}>
              <RoleSelect mode={'multiple'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="countryId" label={'Country'}>
              <CountrySelect />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="languages" label={'Languages'}>
              <LanguageSelect setLabelAsValue={false} mode={'multiple'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="createdDate" label={'Created Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="lastUpdatedDate" label={'Last Updated Date'}>
              <RangePicker
                suffixIcon={<CalendarIcon />}
                className={styles.range_picker}
                popupClassName={'fmg-range-picker'}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </FilterDrawer>
  );
});
